export default __webpack_public_path__ + "3c0fabd1f34daef92de7e548d3204ff8.png";